module.exports = __webpack_public_path__ + "2efc425bcf14c732594b79aee5b5ad10.woff";


//////////////////
// WEBPACK FOOTER
// ./src/client/fonts/Interstate-Regular.woff
// module id = 971
// module chunks = 0